import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAbrechenbareDienstleistungenFilter, IFakturaDlResponseDto, IFakturaRechnungsanlageRequestDto, IRechnungslauf } from "../types/Types";

/**
 * @author mb
 */
export const FakturaAPI = createApi({
    reducerPath: "fakturaAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "faktura",
            credentials: 'include'
        }),
    tagTypes: ['fakturaAPI'], // for caching
    endpoints: (builder) => ({
        getRechnungslauf: builder.mutation<IRechnungslauf, string>(
            {
                query: (uid) => ({
                    url: 'rechnungslauf/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getRechnungslaeufe: builder.mutation<any[], void>(
            {
                query: () => ({
                    url: 'rechnungslauf/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        createOrUpdateRechnungslauf: builder.mutation<IRechnungslauf, IRechnungslauf>(
            {
                query: (dto) => ({
                    url: 'rechnungslauf/',
                    method: 'put',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        deleteRechnungslauf: builder.mutation<void, string>(
            {
                query: (uid) => ({
                    url: 'rechnungslauf/' + uid,
                    method: 'delete',
                    credentials: 'include',
                })
            }
        ),
        getDl: builder.mutation<IFakturaDlResponseDto[], IAbrechenbareDienstleistungenFilter>(
            {
                query: (dto) => ({
                    url: 'getDl',
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
        starteRechnungslauf: builder.mutation<{ blob: Blob; filename: string }, any>(
            {
                query: (dto: IFakturaRechnungsanlageRequestDto) => ({
                    url: 'starteRechnungslauf',
                    method: 'post',
                    credentials: 'include',
                    body: dto,      
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        const disposition = response.headers.get('Content-Disposition');
                        //const filename = disposition?.match(/filename="?(.+?)"?/)?.[1] ?? 'deckblatt.pdf';
                        const filename = disposition?.match(/filename="([^"]+)"/)?.[1] ?? 'rechnung.zip';
                        return { blob, filename };
                    },
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
            }
        ),
        vorschauPdf: builder.mutation<{ blob: Blob; filename: string }, any>(
            {
                query: (uid: string) => ({
                    url: 'vorschauPDF/' + uid,
                    method: 'get',
                    credentials: 'include',
                    responseHandler: async (response) => {
                        const blob = await response.blob();
                        const disposition = response.headers.get('Content-Disposition');
                        const filename = disposition?.match(/filename="?(.+?)"?/)?.[1] ?? 'vorschau.pdf';
                        return { blob, filename };
                    },
                    headers: {
                        'Content-Type': 'application/json',
                    }
                })
            }
        ),
        getAusgangsrechnungen: builder.mutation<any[], void>(
            {
                query: () => ({
                    url: 'ausgangsrechnung/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        storniereAusgangsrechnungen: builder.mutation<void, any>(
            {
                query: (uid: string) => ({
                    url: 'ausgangsrechnung/storno/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        getAktuelleRechnungsnummer: builder.mutation<number, string>(
            {
                query: (kennung: string) => ({
                    url: 'aktuelleRechnungsnr',
                    method: 'get',
                    credentials: 'include',
                    params: {
                        kennung: kennung
                    }
                })
            }
        ),
        setAktuelleRechnungsnummer: builder.mutation<any , {kennung: string, neueRechnungsnummer: number}>(
            {
                query: (dto) => ({
                    url: 'aktuelleRechnungsnr',
                    method: 'put',
                    credentials: 'include',
                    params: {
                        kennung: dto.kennung,
                        neueRechnungsnummer: dto.neueRechnungsnummer
                    }
                })
            }
        ),
        aktiviereAbzurechnendeDienstleistung: builder.mutation<void , string>(
            {
                query: (uid) => ({
                    url: 'aktiviereDienstleistung/' + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        deaktiviereAbzurechnendeDienstleistung: builder.mutation<void , string>(
            {
                query: (uid) => ({
                    url: 'deaktiviereDienstleistung/' + uid,
                    method: 'get',
                    credentials: 'include',
                })
            }
        )
    })
});

export const {

    useGetRechnungslaufMutation,
    useGetRechnungslaeufeMutation,
    useCreateOrUpdateRechnungslaufMutation,
    useDeleteRechnungslaufMutation,
    useGetDlMutation,
    useStarteRechnungslaufMutation,
    useVorschauPdfMutation,
    useGetAusgangsrechnungenMutation,
    useStorniereAusgangsrechnungenMutation,
    useGetAktuelleRechnungsnummerMutation,
    useSetAktuelleRechnungsnummerMutation,
    useAktiviereAbzurechnendeDienstleistungMutation,
    useDeaktiviereAbzurechnendeDienstleistungMutation

} = FakturaAPI;
